import api from '../../../helpers/api';

export const getMyProductsArtisan = (body) => api.post('artisan-product/search-artisan-products/', {...body})

export const getMyArtisanProduct = (id) => api.get(`artisan-product/get-single-product/${id}`)

export const createMyArtisanProduct = (formData) => api.post('artisan-product-staging/create' , {...formData})



export const updateMyArtisanProduct = ( id , formData) => api.post(`artisan-product-staging/update${id}` , {...formData})


export const getMyProductsArtisanPictures = () => api.get('artisan-product/get-products-pictures?offset=0&size=10')